// extracted by mini-css-extract-plugin
export var container = "_gg-0";
export var outlet = "_gg-1";
export var outletEnter = "_gg-2";
export var outletEnterActive = "_gg-3";
export var outletExit = "_gg-4";
export var outletExitActive = "_gg-5";